import {
  User,
  PaginatedResponse,
  UserListParams,
  CreateUserRequest,
  UpdateUserRequest,
} from "@/models/user.model";
import type {
  BalanceHistoryApiResponse,
  BalanceHistoryListParams,
  PaginatedBalanceHistory,
} from "@/models/balanceHistory.model";
import { normalizeBalanceHistoryPagination } from "@/models/balanceHistory.model";
import http from "@/services/http";

class UserService {
  async getMyProfile(): Promise<User> {
    return http.get<User>("/users/me");
  }

  async getUsers(params: UserListParams = {}): Promise<PaginatedResponse<User>> {
    return http.get<PaginatedResponse<User>>("/users", params);
  }

  async getUser(id: string): Promise<User> {
    return http.get<User>(`/users/${id}`);
  }

  async getBalanceHistory(params: BalanceHistoryListParams = {}): Promise<PaginatedBalanceHistory> {
    const response = await http.get<BalanceHistoryApiResponse>(
      "/admin/balance-history",
      params
    );

    return {
      items: response.items || [],
      pagination: normalizeBalanceHistoryPagination(response.pagination, params),
    };
  }

  async createUser(data: CreateUserRequest): Promise<User> {
    return http.post<User>("/users", data);
  }

  async updateUser(id: string, data: UpdateUserRequest): Promise<User> {
    return http.put<User>(`/users/${id}`, data);
  }

  async deleteUser(id: string, permanent = false): Promise<void> {
    return http.delete<void>(`/users/${id}`, permanent ? { permanent: true } : undefined);
  }
}

export default new UserService();
